import { render } from "./CompanyModal.vue?vue&type=template&id=7f20cc40"
import script from "./CompanyModal.vue?vue&type=script&lang=js"
export * from "./CompanyModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__